import { render, staticRenderFns } from "./auth2fa.vue?vue&type=template&id=81c10934"
import script from "./auth2fa.vue?vue&type=script&lang=js"
export * from "./auth2fa.vue?vue&type=script&lang=js"
import style0 from "./auth2fa.vue?vue&type=style&index=0&id=81c10934&prod&lang=postcss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {S2FeedbackToast: require('/usr/src/app/node_modules/front-components/components/ui/notification/FeedbackToast.vue').default})
